// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quests_container__gaQRb {
  transition: all 0.2s linear;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 70px;
  width: 85%;
}
.Quests_container__gaQRb .Quests_title__PPI-z {
  font-size: 28px;
  font-weight: 700;
  align-items: center;
  color: #ffffff;
  font-size: 40px;
  margin-top: 30px;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_categories__SyaTv {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_categories__SyaTv .Quests_category__z1dV2 {
  background-color: rgba(255, 255, 255, 0.1019607843);
  border-radius: 16px;
  color: #fff;
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_categories__SyaTv .Quests_category__z1dV2.Quests_active__r6Swf {
  background-color: rgba(255, 255, 255, 0.2);
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR {
  display: flex;
  gap: 24px;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #333217;
  border-radius: 8px;
  color: #ead40c;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding: 10px 22px;
  position: relative;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #242424;
  border-radius: 8px;
  color: #e0e0e0;
  left: 0;
  padding: 8px 0;
  position: absolute;
  top: 120%;
  width: 170px;
  z-index: 1;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_filterItem__PGbM- {
  cursor: pointer;
  margin-bottom: 3px;
  padding: 6px 16px;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_filterItem__PGbM-:hover {
  background-color: rgba(220, 220, 220, 0.1);
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g .Quests_filterWrapper__rnXUM .Quests_selectedFilter__pArzc {
  background-color: rgba(220, 220, 220, 0.1);
  color: #fff;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g:hover {
  background-color: #494711;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterBlue__QpelO {
  background-color: #193b41;
  color: #0cdcea;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterPurple__f\\+vxm {
  background-color: #3a2159;
  color: #ae6fff;
  transition: all 0.2s linear;
}
.Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filterPurple__f\\+vxm:hover {
  background-color: #4a2c6f;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl {
  align-items: start;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: 24px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #f9f9f9;
  display: flex;
  grid-column: span 4;
  justify-content: center;
  margin-top: 50px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ .Quests_loaderWrapper__HUlmg {
  background-color: #ffffff;
  border-radius: 133px;
  height: 8px;
  margin-top: 32px;
  width: 236px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_loaderContainer__6FmUQ .Quests_loaderWrapper__HUlmg .Quests_loader__wUXsu {
  background-color: #F1F813;
  border-radius: 133px;
  height: 100%;
  animation: Quests_loader__wUXsu 0.5s ease-in-out forwards;
  width: 0;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  grid-column: span 4;
  margin-top: 50px;
  text-align: center;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  margin-top: 20px;
}
.Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q .Quests_link__DCj9i {
  color: #F2F740;
}
.Quests_container__gaQRb .Quests_more__47YgZ {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  position: relative;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #333217;
  border-radius: 8px;
  color: #ead40c;
  cursor: pointer;
  height: 46px;
  transition: all 0.2s linear;
  width: 107px;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button .Quests_loader__wUXsu {
  animation: Quests_spin__abXXa 0.5s linear infinite;
  width: 24px;
}
.Quests_container__gaQRb .Quests_more__47YgZ .Quests_btn__0NAZo button:hover {
  background-color: #494711;
}
.Quests_container__gaQRb .Quests_up__AFGrL {
  align-items: center;
  background-color: #3E3C37;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  transition: all 0.2s linear;
  width: 40px;
}
.Quests_container__gaQRb .Quests_up__AFGrL:hover {
  background-color: #4a2c6f;
}

@keyframes Quests_loader__wUXsu {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@media (max-width: 850px) {
  .Quests_container__gaQRb {
    padding-top: 75px;
  }
  .Quests_container__gaQRb .Quests_title__PPI-z {
    display: block;
    font-size: 36px;
  }
  .Quests_container__gaQRb .Quests_title__PPI-z .Quests_filters__vYbZR .Quests_filter__qYj7g {
    display: inline-flex;
    margin-top: 32px;
    padding: 10px 18px;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl {
    grid-template-columns: 1fr;
    margin-top: 24px;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO {
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
  }
  .Quests_container__gaQRb .Quests_wrapper__69XBl .Quests_empty__2JXSO .Quests_emptyInfo__fEF\\+q {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-top: 20px;
  }
}
@keyframes Quests_spin__abXXa {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Quests/Quests.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AADN;AAGM;EACE,mDAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADR;AAEQ;EACE,0CAAA;AAAV;AAKI;EACE,aAAA;EACA,SAAA;AAHN;AAKM;ECSJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDRM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;AAFR;AAIQ;ECwGN,eAAA;EACA,gBAAA;EACA,kBAAA;EDvGQ,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AADV;AAGU;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AADZ;AAGY;EACE,0CAAA;AADd;AAKU;EACE,0CAAA;EACA,WAAA;AAHZ;AAOQ;EACE,yBAAA;AALV;AASM;EACE,yBAAA;EACA,cAAA;AAPR;AAUM;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;AARR;AAUQ;EACE,yBAAA;AARV;AAcE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;AAZJ;AAcI;EC/FF,eAAA;EACA,gBAAA;EACA,kBAAA;EDgGI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAXN;AAaM;EACE,yBE5HE;EF6HF,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAXR;AAaQ;EACE,yBEvGI;EFwGJ,oBAAA;EACA,YAAA;EACA,yDAAA;EACA,QAAA;AAXV;AAgBI;EC/HF,eAAA;EACA,gBAAA;EACA,kBAAA;EDgII,cE/II;EFgJJ,mBAAA;EACA,gBAAA;EACA,kBAAA;AAbN;AAeM;ECzGJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED0GM,gBAAA;AAZR;AAcQ;EACE,cEjJC;AFqIX;AAkBE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAmBM;ECtHJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDuHM,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;AAhBR;AAkBQ;EACE,kDAAA;EACA,WAAA;AAhBV;AAmBQ;EACE,yBAAA;AAjBV;AAuBE;EACE,mBAAA;EACA,yBEtIe;EFuIf,oBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AArBJ;AAuBI;EACE,yBAAA;AArBN;;AA0BA;EACE;IACE,QAAA;EAvBF;EAyBA;IACE,WAAA;EAvBF;AACF;AA0BA;EACE;IACE,iBAAA;EAxBF;EA0BE;IACE,cAAA;IACA,eAAA;EAxBJ;EA2BM;IACE,oBAAA;IACA,gBAAA;IACA,kBAAA;EAzBR;EA8BE;IACE,0BAAA;IACA,gBAAA;EA5BJ;EA8BI;IC5NJ,eAAA;IACA,gBAAA;IACA,kBAAA;EDiMA;EA4BM;ICnFN,eAAA;IACA,gBAAA;IACA,kBAAA;IDoFQ,gBAAA;EAzBR;AACF;AA+BA;EACE;IACE,uBAAA;EA7BF;EA+BA;IACE,yBAAA;EA7BF;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.container {\n  transition: all 0.2s linear;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 70px;\n  width: 85%;\n\n  .title {\n    font-size: 28px;\n    font-weight: 700;\n    align-items: center;\n    color: #ffffff;\n    font-size: 40px;\n    margin-top: 30px;\n\n    .categories {\n      display: flex;\n      gap: 16px;\n      margin-top: 24px;\n\n      .category {\n        background-color: #FFFFFF1A;\n        border-radius: 16px;\n        color: #fff;\n        padding: 6px 8px;\n        font-size: 14px;\n        font-weight: 600;\n        cursor: pointer;\n        &.active {\n          background-color: #FFFFFF33;\n        }\n      }\n    }\n\n    .filters {\n      display: flex;\n      gap: 24px;\n\n      .filter {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #333217;\n        border-radius: 8px;\n        color: #ead40c;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        height: 46px;\n        padding: 10px 22px;\n        position: relative;\n        transition: all 0.2s linear;\n\n        .filterWrapper {\n          @include body1;\n\n          background-color: #242424;\n          border-radius: 8px;\n          color: #e0e0e0;\n          left: 0;\n          padding: 8px 0;\n          position: absolute;\n          top: 120%;\n          width: 170px;\n          z-index: 1;\n\n          .filterItem {\n            cursor: pointer;\n            margin-bottom: 3px;\n            padding: 6px 16px;\n            transition: all 0.2s linear;\n\n            &:hover {\n              background-color: rgba(220, 220, 220, 0.1);\n            }\n          }\n\n          .selectedFilter {\n            background-color: rgba(220, 220, 220, 0.1);\n            color: #fff;\n          }\n        }\n\n        &:hover {\n          background-color: #494711;\n        }\n      }\n\n      .filterBlue {\n        background-color: #193b41;\n        color: #0cdcea;\n      }\n\n      .filterPurple {\n        background-color: #3a2159;\n        color: #ae6fff;\n        transition: all 0.2s linear;\n\n        &:hover {\n          background-color: #4a2c6f;\n        }\n      }\n    }\n  }\n\n  .wrapper {\n    align-items: start;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    margin-top: 24px;\n\n    .loaderContainer {\n      @include subtitle1b;\n\n      color: #f9f9f9;\n      display: flex;\n      grid-column: span 4;\n      justify-content: center;\n      margin-top: 50px;\n\n      .loaderWrapper {\n        background-color: $c-white;\n        border-radius: 133px;\n        height: 8px;\n        margin-top: 32px;\n        width: 236px;\n\n        .loader {\n          background-color: $c-parimatch;\n          border-radius: 133px;\n          height: 100%;\n          animation: loader 0.5s ease-in-out forwards;\n          width: 0;\n        }\n      }\n    }\n\n    .empty {\n      @include h3;\n\n      color: $c-white;\n      grid-column: span 4;\n      margin-top: 50px;\n      text-align: center;\n\n      .emptyInfo {\n        @include subtitle5;\n\n        margin-top: 20px;\n\n        .link {\n          color: $c-yellow;\n        }\n      }\n    }\n  }\n\n  .more {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    position: relative;\n\n    .btn {\n      button {\n        @include subtitle6m;\n\n        background-color: #333217;\n        border-radius: 8px;\n        color: #ead40c;\n        cursor: pointer;\n        height: 46px;\n        transition: all 0.2s linear;\n        width: 107px;\n\n        .loader {\n          animation: spin 0.5s linear infinite;\n          width: 24px;\n        }\n\n        &:hover {\n          background-color: #494711;\n        }\n      }\n    }\n  }\n\n  .up {\n    align-items: center;\n    background-color: $background-input;\n    border-radius: 100px;\n    cursor: pointer;\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    transition: all 0.2s linear;\n    width: 40px;\n\n    &:hover {\n      background-color: #4a2c6f;\n    }\n  }\n}\n\n@keyframes loader {\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 75px;\n\n    .title {\n      display: block;\n      font-size: 36px;\n\n      .filters {\n        .filter {\n          display: inline-flex;\n          margin-top: 32px;\n          padding: 10px 18px;\n        }\n      }\n    }\n\n    .wrapper {\n      grid-template-columns: 1fr;\n      margin-top: 24px;\n\n      .empty {\n        @include subtitle1b;\n\n        .emptyInfo {\n          @include body1;\n\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Quests_container__gaQRb`,
	"title": `Quests_title__PPI-z`,
	"categories": `Quests_categories__SyaTv`,
	"category": `Quests_category__z1dV2`,
	"active": `Quests_active__r6Swf`,
	"filters": `Quests_filters__vYbZR`,
	"filter": `Quests_filter__qYj7g`,
	"filterWrapper": `Quests_filterWrapper__rnXUM`,
	"filterItem": `Quests_filterItem__PGbM-`,
	"selectedFilter": `Quests_selectedFilter__pArzc`,
	"filterBlue": `Quests_filterBlue__QpelO`,
	"filterPurple": `Quests_filterPurple__f+vxm`,
	"wrapper": `Quests_wrapper__69XBl`,
	"loaderContainer": `Quests_loaderContainer__6FmUQ`,
	"loaderWrapper": `Quests_loaderWrapper__HUlmg`,
	"loader": `Quests_loader__wUXsu`,
	"empty": `Quests_empty__2JXSO`,
	"emptyInfo": `Quests_emptyInfo__fEF+q`,
	"link": `Quests_link__DCj9i`,
	"more": `Quests_more__47YgZ`,
	"btn": `Quests_btn__0NAZo`,
	"spin": `Quests_spin__abXXa`,
	"up": `Quests_up__AFGrL`
};
export default ___CSS_LOADER_EXPORT___;
